module.exports = __webpack_public_path__ + "assets/fd6b7fde250b56658fded0cfdd146f35.mp3";